/* tslint:disable */
/* eslint-disable */

export interface ResponseItemStatusChangeResponse {
    amazonItemId: number;
    amazonItemName: string;
    fromStatusId: number;
    fromStatusName: string;
    toStatusId: number;
    toStatusName: string;
}

export interface ResponseOperationLogResponse {
    id: number;
    userId: number;
    userName: string;
    action: string;
    targetCount: number;
    createdAt: Date;
    statusChanges: ResponseItemStatusChangeResponse[];
}

export interface ResponseGetOperationLogsResponse {
    logs: ResponseOperationLogResponse[];
    total: number;
}

export interface ResponseItemHistoryEntry {
    changedAt: Date;
    userId: number;
    userName: string;
    fromStatusId: number;
    fromStatusName: string;
    toStatusId: number;
    toStatusName: string;
    action: string;
}

export interface ResponseItemStatusHistoryResponse {
    amazonItemId: number;
    amazonItemName: string;
    history: ResponseItemHistoryEntry[];
}

export interface ResponseGetItemStatusHistoryResponse {
    items: ResponseItemStatusHistoryResponse[];
    total: number;
}

export function ResponseGetOperationLogsResponseFromJSON(json: any): ResponseGetOperationLogsResponse {
    if (json == null) return json;
    return {
        logs: (json['logs'] ?? []).map((l: any) => ({
            id: l['id'],
            userId: l['user_id'],
            userName: l['user_name'],
            action: l['action'],
            targetCount: l['target_count'] ?? 0,
            createdAt: new Date(l['created_at']),
            statusChanges: (l['status_changes'] ?? []).map((s: any) => ({
                amazonItemId: s['amazon_item_id'],
                amazonItemName: s['amazon_item_name'],
                fromStatusId: s['from_status_id'],
                fromStatusName: s['from_status_name'],
                toStatusId: s['to_status_id'],
                toStatusName: s['to_status_name'],
            })),
        })),
        total: json['total'],
    };
}

export function ResponseGetItemStatusHistoryResponseFromJSON(json: any): ResponseGetItemStatusHistoryResponse {
    if (json == null) return json;
    return {
        items: (json['items'] ?? []).map((item: any) => ({
            amazonItemId: item['amazon_item_id'],
            amazonItemName: item['amazon_item_name'],
            history: (item['history'] ?? []).map((h: any) => ({
                changedAt: new Date(h['changed_at']),
                userId: h['user_id'],
                userName: h['user_name'],
                fromStatusId: h['from_status_id'],
                fromStatusName: h['from_status_name'],
                toStatusId: h['to_status_id'],
                toStatusName: h['to_status_name'],
                action: h['action'],
            })),
        })),
        total: json['total'],
    };
}
